import { CURRENCY } from '../constants';
import { CurrencyProps } from '../Currency';

const checkCurrencyDefaultPrecision = (
  userLocale: string,
  code: string | undefined,
  currencyDisplay?: CurrencyProps['format'],
) => {
  const numberFormat = new Intl.NumberFormat(userLocale, {
    style: CURRENCY,
    currency: code,
    currencyDisplay,
  }).resolvedOptions();

  return numberFormat.maximumFractionDigits || 0;
};

export default checkCurrencyDefaultPrecision;
